import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

export type SpinnerSize  = 'xs' | 'sm' | 'md' | 'lg';
export type SpinnerColor = 'primary' | 'white' | 'danger' | 'success' | 'muted';

@Component({
    selector: 'app-spinner',
    template: `<div class="spinner" [ngClass]="['size-' + size(), 'color-' + color()]"></div>`,
    styleUrls: ['./spinner.component.scss'],
    standalone: true,
    imports: [CommonModule],
})
export class SpinnerComponent {
    size  = input<SpinnerSize>('sm');
    color = input<SpinnerColor>('primary');
}